import React, {useState, useEffect} from 'react'
import axiosClient from 'api/axiosClient'
import HtmlParser from 'react-html-parser';
import { updateBreadCrumbNews, updateMenuPatent, updateSelecteDetail,  } from 'redux/actions/menu';
import { useParams } from 'react-router';
// ** Loader
import Loader from "react-loader-spinner";
import './style.css';
import { Col, Container, Row,Table } from 'reactstrap';
import { IMAGE_BASE_URL } from 'utils/constants';

export default function ResearchGroup() {
    const {id} = useParams();  
    const [infoGroup, setinfoGroup] = useState([])
    const [loaded, setLoaded] = useState()
    
    
    const pathSplit = window.location.pathname.split('/')
    const lang = pathSplit[1]
    const isVietnamese = lang === 'vi'

    useEffect(() => {
        // set loading to wait get data
        setLoaded(false)
        const requestGroup = `/research_group/${id}`
        axiosClient.get(requestGroup).then(response => {
            const temp = response.data
            setinfoGroup(temp)
        }).catch(error => {
            console.error("Lỗi gọi API!", error)
        })
        
    }, [])
    
    
    return (
        <Container>
        <div className='staffPage' style={{marginTop: '60px'}}>
            <Row>
                <Col md={4} sm={12}>
                    <img alt="img" src={`${IMAGE_BASE_URL}/${infoGroup.image}`} style={{width:'370px',height:'270px'}}></img>
                </Col>
                <Col md={8} sm={12}>
                    <h1 style={{fontSize: 34, fontWeight: 'bold', color:'var(--primary-color)', marginLeft:'30px'}}>{isVietnamese ? infoGroup.name_vi : infoGroup.name}</h1>
                </Col>
            </Row>
            <div className='staff-item' style={{marginTop:'30px'}}>
                <div className='staffbody'>
                    {infoGroup && HtmlParser(isVietnamese ? infoGroup.content_vi : infoGroup.content)}
                </div>
            </div>
        </div>
        </Container>
    )
}
